import { BookOpen, MessageSquareText, Send, FileEdit } from "lucide-react";
import type { StatCardConfig } from "../../common";

/** Figma admin stat cards (dc.html:6982) — values come from live queries. */
export const HELP_ADMIN_STAT_CARDS: StatCardConfig[] = [
  {
    key: "total",
    label: "Total articles",
    icon: BookOpen,
    iconBg: "var(--color-primary-100)",
    iconColor: "var(--color-primary-700)",
  },
  {
    key: "published",
    label: "Published",
    icon: Send,
    iconBg: "var(--color-success-light)",
    iconColor: "var(--color-success-dark)",
  },
  {
    key: "drafts",
    label: "Drafts",
    icon: FileEdit,
    iconBg: "var(--color-bg-muted)",
    iconColor: "var(--color-text-secondary)",
  },
  {
    key: "feedback",
    label: "Feedback responses",
    icon: MessageSquareText,
    iconBg: "var(--color-info-light)",
    iconColor: "var(--color-info)",
  },
];
